import { render, staticRenderFns } from "./FullWidthSlider.vue?vue&type=template&id=7e57e954"
import script from "./FullWidthSlider.vue?vue&type=script&lang=js"
export * from "./FullWidthSlider.vue?vue&type=script&lang=js"
import style0 from "./FullWidthSlider.vue?vue&type=style&index=0&id=7e57e954&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports